import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import {MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { UserService } from 'src/app/services/user.service';
import { UserOptionModel } from '../models/user-option.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-edit-options-dialog',
  templateUrl: './add-edit-options-dialog.component.html',
  styleUrls: ['./add-edit-options-dialog.component.css']
})
export class AddEditOptionsDialogComponent implements OnInit {

  public optionsToAdd: UserOptionModel[] |any = [];
  public datasource = new MatTableDataSource();
  public optionId: number;
  public isUpdateMode: boolean;
  public displayedColumns: string[] = ['propertyName', 'value', 'controlType', 'isEditable', 'isVisible', 'actions'];
  public optionForm = new FormGroup({
    UserId: new FormControl(0),
    Id: new FormControl(0),
    PropertyName: new FormControl('', Validators.required),
    Value: new FormControl('', Validators.required),
    ControlType: new FormControl(0, Validators.required),
    IsEditable: new FormControl(false),
    IsVisible: new FormControl(false)
  });

  public getFormControlByName(controlName: string): FormControl {
    return this.optionForm.get(controlName) as FormControl;
  }


  constructor(
    public dialogRef: MatDialogRef<AddEditOptionsDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any, public httpClient: HttpClient,
     private snotifyService: ToastrService,
    private userService: UserService
  ) {
    
   }

  ngOnInit() {
    this.getFormControlByName('UserId').setValue(this.data.userId);
    if (this.data.userOptions) {
      this.optionsToAdd = this.data.userOptions;
      this.datasource = new MatTableDataSource(this.optionsToAdd);
    }
    if (this.data.option) {
      this.isUpdateMode = true;
      this.optionForm.patchValue(this.data.option)
    }
    else {
      this.isUpdateMode = false;
    }
  }

  public addOptionToList() {
    this.optionsToAdd.push(this.optionForm.value);
    this.datasource._updateChangeSubscription();
    this.optionForm.reset();
    this.optionForm.patchValue({ControlType: 0,
      UserId: 0,
      Id: 0,
      IsVisible:false,
      IsEditable:false
    });
  }
  public updateOption() {

    if(this.optionForm.value.Id){
      this.userService.editUserOption(this.optionForm.value).subscribe(res => {
      
        this.dialogRef.close('updated');
      })
    }else{
      this.dialogRef.close(this.optionForm.value);
    }

  }
  public deleteOptionFromAddedOptions(option: UserOptionModel) {
    this.optionsToAdd = this.optionsToAdd.filter(opt => opt != option);

    this.datasource=new MatTableDataSource(this.optionsToAdd);

  }
  public save() {
    if (this.optionsToAdd.length == 0) {
      return;
    }
    this.optionsToAdd.forEach(element => {
      element.controlType = Number(element.controlType);
    });
    this.dialogRef.close(this.optionsToAdd);
  }

  showMessage(message, type) {
    switch (type) {
      case 'success':
        this.snotifyService.success("", message, {
          timeOut: 2000,
          progressBar: true,
          tapToDismiss: true,
        });
        break;
      case 'error':
        this.snotifyService.error("", message, {
          timeOut: 2000,
          progressBar: true,
          tapToDismiss: true,
        });
        break;
      default:
        break;
    }

  }
  public deleteUserOption(element: UserOptionModel) {
    this.userService.deleteUserOption(element.Id).subscribe((res: any) => {
      if ( this.optionsToAdd.length>=1) {
        this.optionsToAdd = this.optionsToAdd.filter(opt => opt != element);
      }

    });
  }
  close() {
    this.dialogRef.close(this.data.option);
  }

  activeHandler(event) {
    //this.optionChecked = event.target.checked;
  }
}
